import React from 'react';
import cc from 'classcat';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-tag_1-2-0_co-tag {\n  display: inline-block;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  padding: 0;\n  margin: 0;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  box-sizing: border-box;\n  color: var(--gray-700);\n  background-color: var(--gray-300);\n  font-family: var(--font-family);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--tiny {\n  font-size: 10px;\n  padding: 0 var(--base-spacing-size, 4px);\n  border-radius: 12px;\n  height: 16px;\n  min-width: 16px;\n  line-height: 16px;\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--small {\n  font-size: 12px;\n  padding: 0 calc(var(--base-spacing-size, 4px) * 2);\n  border-radius: 12px;\n  height: 20px;\n  min-width: 20px;\n  line-height: 20px;\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--medium, .react-tag_1-2-0_co-tag {\n  font-size: 12px;\n  padding: 0 calc(var(--base-spacing-size, 4px) * 3);\n  border-radius: 12px;\n  height: 24px;\n  min-width: 24px;\n  line-height: 24px;\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--large {\n  font-size: 14px;\n  padding: 0 calc(var(--base-spacing-size, 4px) * 4);\n  border-radius: 16px;\n  height: 32px;\n  min-width: 32px;\n  line-height: 32px;\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--theme {\n  color: var(--white);\n  background-color: var(--primary-600);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--light-theme {\n  color: var(--primary-600);\n  background-color: var(--primary-300);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--gray {\n  color: var(--white);\n  background-color: var(--gray-600);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--green {\n  color: var(--white);\n  background-color: var(--green-700);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--light-green {\n  color: var(--green-700);\n  background-color: var(--green-200);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--yellow {\n  color: var(--gray-800);\n  background-color: var(--yellow-600);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--light-yellow {\n  color: var(--gray-800);\n  background-color: var(--yellow-300);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--red {\n  color: var(--white);\n  background-color: var(--red-700);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--light-red {\n  color: var(--red-700);\n  background-color: var(--red-200);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--purple {\n  color: var(--white);\n  background-color: var(--purple-700);\n}\n.react-tag_1-2-0_co-tag.react-tag_1-2-0_co-tag--light-purple {\n  color: var(--purple-700);\n  background-color: var(--purple-300);\n}\n.react-tag_1-2-0_co-tag[data-co-disabled] {\n  opacity: 0.5;\n  user-select: none;\n  pointer-events: none;\n}\n.react-tag_1-2-0_co-tag[data-co-disabled] [disabled],\n.react-tag_1-2-0_co-tag[data-co-disabled] [data-co-disabled] {\n  opacity: 1;\n}\n\n.react-tag_1-2-0_co-selectable-tag {\n  display: inline-block;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  padding: 0;\n  margin: 0;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  box-sizing: border-box;\n  background-color: var(--white);\n  color: var(--primary-600);\n  border: 1px solid var(--primary-600);\n  transition-property: background-color, color, border-color;\n  transition-duration: 0.5s;\n  transition-timing-function: ease;\n}\n.react-tag_1-2-0_co-selectable-tag.react-tag_1-2-0_co-selectable-tag--small {\n  font-size: 12px;\n  padding: 0 calc(var(--base-spacing-size, 4px) * 2);\n  border-radius: 12px;\n  height: 20px;\n  min-width: 20px;\n  line-height: 20px;\n}\n.react-tag_1-2-0_co-selectable-tag.react-tag_1-2-0_co-selectable-tag--medium, .react-tag_1-2-0_co-selectable-tag {\n  font-size: 12px;\n  padding: 0 calc(var(--base-spacing-size, 4px) * 3);\n  border-radius: 12px;\n  height: 24px;\n  min-width: 24px;\n  line-height: 24px;\n}\n.react-tag_1-2-0_co-selectable-tag.react-tag_1-2-0_co-selectable-tag--large {\n  font-size: 14px;\n  padding: 0 calc(var(--base-spacing-size, 4px) * 4);\n  border-radius: 16px;\n  height: 32px;\n  min-width: 32px;\n  line-height: 32px;\n}\n.react-tag_1-2-0_co-selectable-tag:not([data-disabled]):not([data-co-disabled])[data-co-hover], .react-tag_1-2-0_co-selectable-tag:not([data-disabled]):not([data-co-disabled]):hover {\n  background-color: var(--primary-300);\n}\n.react-tag_1-2-0_co-selectable-tag:not([data-disabled]):not([data-co-disabled])[data-co-hover].react-tag_1-2-0_co-selectable-tag--selected, .react-tag_1-2-0_co-selectable-tag:not([data-disabled]):not([data-co-disabled]):hover.react-tag_1-2-0_co-selectable-tag--selected {\n  background-color: var(--primary-700);\n}\n.react-tag_1-2-0_co-selectable-tag.react-tag_1-2-0_co-selectable-tag--selected {\n  background-color: var(--primary-600);\n  color: var(--white);\n  border: 1px solid transparent;\n}\n.react-tag_1-2-0_co-selectable-tag[data-co-disabled], .react-tag_1-2-0_co-selectable-tag[data-disabled] {\n  opacity: 0.5;\n}\n.react-tag_1-2-0_co-selectable-tag[data-co-focus-within], .react-tag_1-2-0_co-selectable-tag:focus-within {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--primary-400);\n}\n.react-tag_1-2-0_co-selectable-tag input[type=checkbox] {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n.react-tag_1-2-0_co-selectable-tag input[type=checkbox][data-co-disabled], .react-tag_1-2-0_co-selectable-tag input[type=checkbox][disabled] {\n  cursor: not-allowed;\n}";
var styles = {
  "co-tag": "react-tag_1-2-0_co-tag",
  "co-tag--tiny": "react-tag_1-2-0_co-tag--tiny",
  "co-tag--small": "react-tag_1-2-0_co-tag--small",
  "co-tag--medium": "react-tag_1-2-0_co-tag--medium",
  "co-tag--large": "react-tag_1-2-0_co-tag--large",
  "co-tag--theme": "react-tag_1-2-0_co-tag--theme",
  "co-tag--light-theme": "react-tag_1-2-0_co-tag--light-theme",
  "co-tag--gray": "react-tag_1-2-0_co-tag--gray",
  "co-tag--green": "react-tag_1-2-0_co-tag--green",
  "co-tag--light-green": "react-tag_1-2-0_co-tag--light-green",
  "co-tag--yellow": "react-tag_1-2-0_co-tag--yellow",
  "co-tag--light-yellow": "react-tag_1-2-0_co-tag--light-yellow",
  "co-tag--red": "react-tag_1-2-0_co-tag--red",
  "co-tag--light-red": "react-tag_1-2-0_co-tag--light-red",
  "co-tag--purple": "react-tag_1-2-0_co-tag--purple",
  "co-tag--light-purple": "react-tag_1-2-0_co-tag--light-purple",
  "co-selectable-tag": "react-tag_1-2-0_co-selectable-tag",
  "co-selectable-tag--small": "react-tag_1-2-0_co-selectable-tag--small",
  "co-selectable-tag--medium": "react-tag_1-2-0_co-selectable-tag--medium",
  "co-selectable-tag--large": "react-tag_1-2-0_co-selectable-tag--large",
  "co-selectable-tag--selected": "react-tag_1-2-0_co-selectable-tag--selected"
};
styleInject(css);

const getClassName = modifier => modifier ? `co-tag--${modifier}` : "";

const Tag = ({
  className = "",
  forwardedRef,
  color,
  size = "medium",
  disabled,
  ...props
}) => {
  const classStyles = [styles["co-tag"], styles[getClassName(size)], {
    [styles[getClassName(color)]]: color
  }, className];
  return React.createElement("span", _extends({
    className: cc(classStyles),
    ref: forwardedRef,
    "data-co-disabled": disabled || undefined
  }, props, {
    "data-co-name": "Tag",
    "data-co-version": "1.2.0",
    "data-co-project": "cobalt"
  }));
};

const getClassName$1 = modifier => modifier ? `co-selectable-tag--${modifier}` : "";

const SelectableTag = ({
  children,
  className = "",
  forwardedRef,
  style,
  size = "medium",
  disabled,
  selected,
  onChange = () => {},
  id,
  ...props
}) => {
  const classStyles = [styles["co-selectable-tag"], styles[getClassName$1(size)], {
    [styles[getClassName$1("selected")]]: selected
  }, className];

  const handleChange = e => onChange(e.target.checked);

  return React.createElement("label", {
    htmlFor: id,
    className: cc(classStyles),
    "data-co-disabled": disabled || undefined,
    style: style,
    "data-co-name": "SelectableTag",
    "data-co-version": "1.2.0",
    "data-co-project": "cobalt"
  }, React.createElement("input", _extends({
    ref: forwardedRef,
    id: id,
    type: "checkbox",
    disabled: disabled,
    checked: !!selected,
    onChange: handleChange
  }, props)), children);
};

export default Tag;
export { SelectableTag };
